// extracted by css-extract-rspack-plugin
export default {"container":"ai-loader_container__JnWMg","animationContainer":"ai-loader_animationContainer__ThXXt"};